













import Getters from '@/mixins/Getters'
import { Component, Mixins } from 'vue-property-decorator'

@Component({
  name: 'DataAddButton'
})
export default class DataAddButton extends Mixins(Getters) {
  // Push empty row to store
  protected addDataRow() {
    this.dataStore.commitTxDataPushEmpty()
  }
}
